import { Pipe, PipeTransform } from '@angular/core';
import { User } from 'src/app/core/user/user.types';

@Pipe({
    name: 'hasPermission',
    pure: true // Pure pipe - only recalculates when input reference changes
    ,
    standalone: false
})
export class HasPermissionPipe implements PipeTransform {

  /**
   * Check if user has a specific permission enabled
   *
   * @param user - User object with permissions array
   * @param permissionName 
   * @returns true if permission is enabled, false otherwise
   */
  transform(user: User, permissionName: string): boolean {
    if (!user || !user.permissions || !permissionName) {
      return false;
    }

    // Loop through all permission modules
    for (const module of user.permissions) {
      if (!module.permissions) {
        continue;
      }

      // Search for the specific permission within this module
      const permission = module.permissions.find(p => p.value === permissionName);

      if (permission) {
        // Found the permission, return its enabled status
        return permission.enabled;
      }
    }

    // Permission not found in any module
    return false;
  }
}
